/* Common imports */
import React from "react";

/* Componennt imports */
import Layout from "../components/layout-components/Layout";
import SectionOne from "../components/page-sections/menu-page/SectionOne";
import MenuTab from "../components/page-sections/menu-page/MenuTab";
import ContactUs from "../components/page-sections/home-page/ContactUs";

const Menu = () => {
  return (
    <React.Fragment>
      <Layout>
        <SectionOne />
        <MenuTab />
        <ContactUs />
      </Layout>
    </React.Fragment>
  );
};

export default Menu;
